module.exports = __webpack_public_path__ + "../resources/images/illustration_sent-2fdb307ebb9adacfa49e6ac278da493f.svg";